import React from 'react';
import './App.css';
import Quotes from './components/Quotes';

function App() {
  return (
    <div className="App">
      <Quotes />
      <footer>Coded By Kesinee</footer>
    </div>
  );
}

export default App;
